<template>
  <div class="edit-wrapper">
    <div class="edit-form">
      <el-tabs class="edit-tabs" v-model="activeName" :stretch="true">
        <div class="edit-title">
          <h4 style="text-align: left">
            Edit Order # {{ orderForm.shippingNo }}
          </h4>
          <i
            class="el-icon-close"
            @click="closeEditor"
            style="cursor: pointer; font-size: 24px"
          ></i>
        </div>
        <el-tab-pane class="tab-panel" label="From" name="shipFrom">
          <div>
            <el-form
              :rules="rules.shipFrom"
              :model="orderForm.shipFrom"
              ref="shipFrom"
            >
              <el-form-item label="Name" prop="name">
                <el-input
                  placeholder="Enter Sender's Name"
                  v-model="orderForm.shipFrom.name"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="Phone Number" prop="phone">
                <el-input
                  placeholder="Enter Sender's Phone Number"
                  type="number"
                  v-model="orderForm.shipFrom.phone"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="Address" prop="address1">
                <el-input
                  placeholder="Enter Sender's Address"
                  v-model="orderForm.shipFrom.address1"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="Apt / Suite #" prop="address2">
                <el-input
                  placeholder="Enter Apt/Suite #"
                  v-model="orderForm.shipFrom.address2"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="City" prop="city">
                <el-input
                  placeholder="Enter Sender's City"
                  v-model="orderForm.shipFrom.city"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="State" prop="state">
                <el-input
                  placeholder="Enter Sender's State"
                  v-model="orderForm.shipFrom.state"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="Postal Code" prop="postal">
                <el-input
                  placeholder="Enter Sender's Postal Code"
                  type="number"
                  v-model="orderForm.shipFrom.postal"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="Country" prop="country">
                <el-input
                  placeholder="Enter Sender's Country"
                  v-model="orderForm.shipFrom.country"
                  disabled
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane class="tab-panel" label="To" name="shipTo">
          <div>
            <el-form
              :rules="rules.shipTo"
              :model="orderForm.shipTo"
              ref="shipTo"
            >
              <el-form-item label="Name" prop="name">
                <el-input
                  placeholder="Enter Recipient's Name"
                  v-model="orderForm.shipTo.name"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="Phone Number" prop="phone">
                <el-input
                  placeholder="Enter Recipient's Phone Number"
                  type="number"
                  v-model="orderForm.shipTo.phone"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="ID Number" prop="ID">
                <el-input
                  placeholder="Enter Recipient's ID Number"
                  v-model="orderForm.shipTo.ID"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="Region" prop="province">
                <el-row>
                  <el-col :span="24" style="display: flex">
                    <el-cascader
                      :options="locationOption"
                      v-model="shipToLocation"
                      placeholder="Province / City / District"
                      style="width: 100%"
                    ></el-cascader>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="Address" prop="addressInfo">
                <el-input
                  placeholder="Enter Recipient's Address Info"
                  v-model="orderForm.shipTo.addressInfo"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="Postal Code" prop="postal">
                <el-input
                  placeholder="Enter Recipient's Postal Code"
                  type="number"
                  v-model="orderForm.shipTo.postal"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="Country" prop="country">
                <el-input
                  placeholder="Enter Recipient's Country"
                  v-model="orderForm.shipTo.country"
                  disabled
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane class="tab-panel" label="Package Detail" name="packDetail">
          <div>
            <el-form
              :rules="rules.packDetail"
              :model="orderForm.packDetail"
              ref="packDetail"
            >
              <el-form-item
                label="Package total Weight (LB): "
                prop="totalWeight"
              >
                <div>
                  <span style="font-weight: bold; font-size: 130%">{{
                    newTotalWeight
                  }}</span>
                </div>
                <!-- <el-input placeholder="Estimate your package weight(LB)" v-model="orderForm.packDetail.totalWeight" clearable></el-input> -->
              </el-form-item>
              <el-form-item
                :label="'Item ' + (index + 1)"
                v-for="(item, index) in orderForm.packDetail.items"
                :key="item.key"
              >
                <el-row style="display: flex; justify-content: space-between">
                  <el-col :span="14">
                    <el-form-item style="margin-bottom: 12px; display: flex">
                      <el-select
                        placeholder="Select from category"
                        v-model="item.category"
                      >
                        <el-option
                          v-for="item in categoryOption"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      circle
                      @click="deleteItem(item)"
                      size="small"
                    ></el-button>
                  </el-col>
                </el-row>
                <el-form-item v-show="item.category">
                  <el-input
                    placeholder="Enter item name with brand"
                    v-model="item.name"
                  >
                    <template slot="prepend">Name w/ Brand</template>
                  </el-input>
                </el-form-item>
                <el-form-item v-show="item.category">
                  <el-input
                    placeholder="Enter item quantity"
                    type="number"
                    v-model="item.qty"
                  >
                    <template slot="prepend">Qty.</template>
                  </el-input>
                </el-form-item>
                <el-form-item v-show="item.category">
                  <el-input
                    placeholder="Enter item price"
                    type="number"
                    v-model="item.price"
                  >
                    <template slot="prepend">Unit Price $</template>
                  </el-input>
                </el-form-item>
                <el-form-item v-show="item.category">
                  <el-input
                    placeholder="Enter the total weight for this item"
                    type="number"
                    v-model="item.weight"
                  >
                    <template slot="prepend">Item Weight / LB</template>
                    <template slot="append">
                      <el-tooltip
                        content="Total weight for this item, will be used to estimate your shipping fee."
                        placement="top"
                      >
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item v-show="categoryRule[item.category]">
                  <el-input
                    placeholder="Enter item specification"
                    v-model="item.spec"
                  >
                    <template slot="prepend">Spec.</template>
                    <el-select
                      v-model="item.specUnit"
                      slot="append"
                      placeholder="Select"
                      class="specSelect"
                    >
                      <el-option label="克 g" value="克 g"></el-option>
                      <el-option label="毫升 mL" value="毫升 mL"></el-option>
                      <el-option
                        label="粒 tablets or capsules"
                        value="粒 tablets or capsules"
                      ></el-option>
                      <el-option label="盎司 oz" value="盎司 oz"></el-option>
                      <el-option label="Other" value="Other"></el-option>
                    </el-select>
                  </el-input>
                </el-form-item>
              </el-form-item>
              <div
                style="
                  width: 100%;
                  margin-top: 16px;
                  box-sizing: border-box;
                  display: flex;
                  justify-content: flex-end;
                "
              >
                <el-button
                  icon="el-icon-plus"
                  circle
                  @click="addItem"
                ></el-button>
              </div>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane class="tab-panel" label="Additional Info" name="info">
          <div>
            <el-form
              :rules="rules.addInfo"
              :model="orderForm.addInfo"
              ref="info"
            >
              <!-- <el-form-item label="是否需要包装 Packing box by store?" prop='packing' style="display: flex;flex-direction: column; text-align:left">
                <div @click="selectPacking(true)">
                  <el-radio v-model="orderForm.addInfo.packing" label="是 Yes (包税模式运费较高，B2C运费无影响)"></el-radio>
                </div>
                <div @click="selectPacking(false)">
                  <el-radio v-model="orderForm.addInfo.packing" label="否 No (包税模式运费较低，B2C运费无影响)"></el-radio>
                </div>
              </el-form-item>
              <el-form-item label="选择您需要的保费 Insurance Fee" prop='insurance' style="display: flex;flex-direction: column; text-align:left">
                <div @click="insuranceFee(0)">
                  <el-radio v-model="orderForm.addInfo.insurance" label="Free（免费），如包裹丢失最高赔付$100"></el-radio>
                </div>
                <div @click="insuranceFee(5)">
                  <el-radio v-model="orderForm.addInfo.insurance" label="$5，如包裹丢失最高赔付$200"></el-radio>
                </div>
                <div @click="insuranceFee(10)">
                  <el-radio v-model="orderForm.addInfo.insurance" label="$10，如包裹丢失最高赔付$300"></el-radio>
                </div>
                <div @click="insuranceFee(15)">
                  <el-radio v-model="orderForm.addInfo.insurance" label="$15，如包裹丢失最高赔付$400"></el-radio>
                </div>
              </el-form-item> -->
              <el-form-item label="总计 Total ($)" prop="totalFee">
                <el-input
                  placeholder="Total ($)"
                  v-model="newTotalFee"
                  type="number"
                ></el-input>
              </el-form-item>
              <el-form-item label="运单号 Shipping NO." prop="shippingNumber">
                <el-input
                  placeholder="Shipping NO."
                  v-model="orderForm.shippingNo"
                  type="text"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="Delivery Status"
                prop="deliveryStatus"
                style="display: flex; flex-direction: column; text-align: left"
              >
                <div @click="deliveryStatus(0)">
                  <el-radio
                    v-model="orderForm.addInfo.deliveryStatus"
                    label="待收件"
                  ></el-radio>
                </div>
                <div @click="deliveryStatus(1)">
                  <el-radio
                    v-model="orderForm.addInfo.deliveryStatus"
                    label="已收件"
                  ></el-radio>
                </div>
                <div @click="deliveryStatus(2)">
                  <el-radio
                    v-model="orderForm.addInfo.deliveryStatus"
                    label="已发出芝加哥"
                  ></el-radio>
                </div>
                <div @click="deliveryStatus(3)">
                  <el-radio
                    v-model="orderForm.addInfo.deliveryStatus"
                    label="已到达中国"
                  ></el-radio>
                </div>
                <div @click="deliveryStatus(4)">
                  <el-radio
                    v-model="orderForm.addInfo.deliveryStatus"
                    label="中国配送中"
                  ></el-radio>
                </div>
                <div @click="deliveryStatus(5)">
                  <el-radio
                    v-model="orderForm.addInfo.deliveryStatus"
                    label="已到达"
                  ></el-radio>
                </div>
              </el-form-item>
              <el-form-item label="备注 Remark" prop="remark">
                <el-input
                  placeholder="Leave a remark"
                  v-model="orderForm.addInfo.remark"
                  clearable
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane class="tab-panel" label="Tax & Fee" name="fee">
          <div>
            <el-form  ref="shippingMethod">
              <el-form-item label="选择计费方式" prop="shippingMethod" style="display: flex;flex-direction: column; text-align:left">
                <div>
                  <el-tag v-if="feesDetail.error !== null" type="danger">订单信息不完整无法计算费率(Missing info for calculating the fee)</el-tag>
                  <el-card>
                    <el-radio v-model="newShippingMethod" label="b2c" style="font-size: 150%; font-weight: bold;">B2C (电商模式)</el-radio>
                    <div>Shipping: $ {{ feesDetail.b2c.shipping }}</div>
                    <div>Insurance: $ {{ feesDetail.b2c.insurance }}</div>
                    <div>Packing: {{ orderForm.addInfo.packaged ? '打包' : '不打包' }}</div>
                    <div>Tax: $ {{ feesDetail.b2c.tax }}</div>
                    <div style="font-size: 120%; font-weight: bold;">Total: $ {{ feesDetail.b2c.total }}</div>
                  </el-card>
                </div>
                <div>
                  <el-card>
                    <el-radio v-model="newShippingMethod" label="noTax" style="font-size: 150%; font-weight: bold;">Tax Free (包税模式)</el-radio>
                    <div v-if="!orderForm.addInfo.packaged">
                      <div>Shipping: $ {{ feesDetail.unpackaged.shipping }}</div>
                      <div>Insurance: $ {{ feesDetail.unpackaged.insurance }}</div>
                      <div>Packing: {{ orderForm.addInfo.unpackaged ? '打包' : '不打包' }}</div>
                      <div>Tax: $ {{ feesDetail.unpackaged.tax }}</div>
                      <div style="font-size: 120%; font-weight: bold;">Total: $ {{ feesDetail.unpackaged.total }}</div>
                    </div>
                    <div v-if="orderForm.addInfo.packaged">
                      <div>Shipping: $ {{ feesDetail.packaged.shipping }}</div>
                      <div>Insurance: $ {{ feesDetail.packaged.insurance }}</div>
                      <div>Packing: {{ orderForm.addInfo.packaged ? '打包' : '不打包' }}</div>
                      <div>Tax: $ {{ feesDetail.packaged.tax }}</div>
                      <div style="font-size: 120%; font-weight: bold;">Total: $ {{ feesDetail.packaged.total }}</div>
                    </div>
                  </el-card>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane> -->
      </el-tabs>
      <div
        style="width: 100%; text-align: left; color: #f56c6c; font-size: 14px"
      >
        {{ warningTxt }}
      </div>
      <div style="margin: 2rem auto 3rem auto">
        <el-button type="primary" @click="saveEdit"> Save </el-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable handle-callback-err */

import { ChinaRegion } from '../../public/js/ChinaRegion'
import { calcShippingFee, postEdit } from '../../public/js/shipping'

export default {
  name: 'OrderEditor',
  props: ['order', 'user'],
  data () {
    return {
      orderForm: this.order,
      activeName: 'shipFrom',
      locationOption: ChinaRegion,
      shipToLocation: [
        this.order.shipTo.province,
        this.order.shipTo.city,
        this.order.shipTo.district
      ],
      newShippingMethod: this.order.addInfo.shippingMethod,
      newTotalFee: this.order.totalFee,
      rules: {
        shipFrom: rules,
        shipTo: rulesReceiver,
        packDetail: rulesItems,
        addInfo: rulesAddInfo
      },
      warningTxt: '',
      categoryOption: [
        {
          value: 'Health_Supplement',
          label: 'Health Supplement'
        },
        {
          value: 'Baby_Formula',
          label: 'Baby Formula (Milk Powder)'
        },
        {
          value: 'Baby_Care',
          label: 'Baby_Care'
        },
        {
          value: 'Clothes',
          label: 'Clothes'
        },
        {
          value: 'Daily_Necessities',
          label: 'Daily Necessities'
        },
        {
          value: 'Shoes',
          label: 'Shoes'
        },
        {
          value: 'Bag',
          label: 'Bag'
        },
        {
          value: 'Electronics',
          label: 'Electronics'
        },
        {
          value: 'Accessories',
          label: 'Accessories'
        },
        {
          value: 'Cosmetic',
          label: 'Cosmetic'
        },
        {
          value: 'Watch',
          label: 'Watch'
        },
        {
          value: 'Other',
          label: 'Other'
        }
      ],
      categoryRule: {
        Health_Supplement: true,
        Baby_Formula: true,
        Baby_Care: false,
        Clothes: false,
        Daily_Necessities: false,
        Shoes: false,
        Bag: false,
        Electronics: false,
        Accessories: false,
        Cosmetic: false,
        Watch: false,
        other: false
      }
    }
  },
  methods: {
    validateEdit: function () {},
    addItem: function () {
      if (this.orderForm.packDetail.items.length < 10) {
        this.orderForm.packDetail.items.push({
          category: '',
          key: Date.now(),
          name: '',
          qty: '',
          price: '',
          spec: '',
          specUnit: '克 g',
          weight: 0
        })
      } else {
        this.$notify.info({
          title: '提示 Tips',
          message:
            '</p>单包裹种类上限为10种</p><p>Limited to 10 items in a package</p>',
          dangerouslyUseHTMLString: true
        })
      }
    },
    deleteItem: function (item) {
      var index = this.orderForm.packDetail.items.indexOf(item)
      if (index !== -1 && this.orderForm.packDetail.items.length > 1) {
        this.orderForm.packDetail.items.splice(index, 1)
      } else if (index !== -1 && this.orderForm.packDetail.items.length === 1) {
        this.$notify.info({
          title: '提示 Tips',
          message:
            '</p>至少包含一个物品</p><p>At least one item in a package</p>',
          dangerouslyUseHTMLString: true
        })
      }
    },
    selectPacking: function (packing) {
      if (packing) {
        this.orderForm.addInfo.packing =
          '是 Yes (包税模式运费较高，B2C运费无影响)'
        this.orderForm.addInfo.packaged = true
      } else {
        this.orderForm.addInfo.packing =
          '否 No (包税模式运费较低，B2C运费无影响)'
        this.orderForm.addInfo.packaged = false
      }
    },
    insuranceFee: function (insuranceFee) {
      if (insuranceFee === 0) {
        this.orderForm.addInfo.insurance =
          'Free（免费），如包裹丢失最高赔付$100'
        this.orderForm.addInfo.insuranceFee = insuranceFee
      } else if (insuranceFee === 5) {
        this.orderForm.addInfo.insurance = '$5，如包裹丢失最高赔付$200'
        this.orderForm.addInfo.insuranceFee = insuranceFee
      } else if (insuranceFee === 10) {
        this.orderForm.addInfo.insurance = '$10，如包裹丢失最高赔付$300'
        this.orderForm.addInfo.insuranceFee = insuranceFee
      } else if (insuranceFee === 15) {
        this.orderForm.addInfo.insurance = '$15，如包裹丢失最高赔付$400'
        this.orderForm.addInfo.insuranceFee = insuranceFee
      }
    },
    deliveryStatus: function (status) {
      const availabeStatus = [
        '待收件',
        '已收件',
        '已发出芝加哥',
        '已到达中国',
        '中国配送中',
        '已到达'
      ]
      this.orderForm.addInfo.deliveryStatus = availabeStatus[status]
    },
    saveEdit: function () {
      if (!(this.feesDetail.error === null)) {
        // console.log('fees error, pre-post check failed')
        return 'Error'
      }
      let order = JSON.parse(JSON.stringify(this.orderForm))
      order.packDetail.totalWeight = this.newTotalWeight
      order.addInfo.shippingMethod = this.newShippingMethod
      order.totalFee = Number.parseFloat(this.newTotalFee).toFixed(2)

      // if (!order.addInfo.packaged && order.addInfo.shippingMethod === "noTax") {
      //   // 不打包 包税
      //   // console.log("不打包 包税");
      //   order.shippingFee = this.feesDetail.unpackaged.shipping;
      //   order.tax = this.feesDetail.unpackaged.tax;
      //   order.totalFee = this.feesDetail.unpackaged.total;
      // }
      // if (order.addInfo.packaged && order.addInfo.shippingMethod === "noTax") {
      //   // 打包 包税
      //   // console.log("打包 包税");
      //   order.shippingFee = this.feesDetail.packaged.shipping;
      //   order.tax = this.feesDetail.packaged.tax;
      //   order.totalFee = this.feesDetail.packaged.total;
      // }
      // if (order.addInfo.shippingMethod === "b2c") {
      //   // b2c mode
      //   // console.log("b2c");
      //   order.shippingFee = this.feesDetail.b2c.shipping;
      //   order.tax = this.feesDetail.b2c.tax;
      //   order.totalFee = this.feesDetail.b2c.total;
      // }

      // console.log('Order ready to be post =>')
      // console.log(order)
      postEdit(order, this.user)
        .then((result) => {
          // console.log(result)
          this.$notify.info({
            title: '成功 Success',
            message: '</p>订单已更新</p><p>Order has been updated</p>',
            dangerouslyUseHTMLString: true
          })
          this.closeEditor()
        })
        .catch((err) => {
          // console.log(err)
        })
    },
    closeEditor: function () {
      this.$emit('close-editor')
    }
  },
  computed: {
    feesDetail: function () {
      try {
        let fees = calcShippingFee(
          this.orderForm.packDetail.items,
          this.orderForm.shipTo.province
        )
        // console.log(fees)
        let feesDetail = {
          error: null
        }
        // no tax - unpackaged
        feesDetail.unpackaged = {
          tax: '0.00',
          shipping: fees.unpackaged,
          insurance: this.orderForm.addInfo.insuranceFee.toFixed(2)
        }
        feesDetail.unpackaged.total = (
          parseFloat(feesDetail.unpackaged.tax) +
          parseFloat(feesDetail.unpackaged.shipping) +
          parseFloat(feesDetail.unpackaged.insurance)
        ).toFixed(2)
        for (let data in feesDetail.unpackaged) {
          if (isNaN(feesDetail.unpackaged[data])) {
            feesDetail.error = 'Some fields are N/A'
          }
        }

        // no tax - packaged
        feesDetail.packaged = {
          tax: '0.00',
          shipping: fees.packaged,
          insurance: this.orderForm.addInfo.insuranceFee.toFixed(2)
        }
        feesDetail.packaged.total = (
          parseFloat(feesDetail.packaged.tax) +
          parseFloat(feesDetail.packaged.shipping) +
          parseFloat(feesDetail.packaged.insurance)
        ).toFixed(2)
        for (let data in feesDetail.packaged) {
          if (isNaN(feesDetail.packaged[data])) {
            feesDetail.error = 'Some fields are N/A'
          }
        }

        // b2c
        feesDetail.b2c = {
          tax: fees.tax,
          shipping: fees.b2c,
          insurance: this.orderForm.addInfo.insuranceFee.toFixed(2)
        }
        feesDetail.b2c.total = (
          parseFloat(feesDetail.b2c.tax) +
          parseFloat(feesDetail.b2c.shipping) +
          parseFloat(feesDetail.b2c.insurance)
        ).toFixed(2)
        for (let data in feesDetail.b2c) {
          if (isNaN(feesDetail.b2c[data])) {
            feesDetail.error = 'Some fields are N/A'
          }
        }

        return feesDetail
      } catch (error) {
        // console.log(error)
        return {
          error: 'Unable to calculate fees, missing information!'
        }
      }
    },
    newTotalWeight: function () {
      // calculate the total weight of the package
      // console.log('calc new total weight')
      let items = this.orderForm.packDetail.items
      let weight = 0.0
      for (var i = 0; i < items.length; i++) {
        let item = items[i]
        weight += parseFloat(item.weight)
      }
      return weight.toFixed(2)
    }
  },
  watch: {
    shipToLocation: function () {
      this.orderForm.shipTo.province = this.shipToLocation[0]
      this.orderForm.shipTo.city = this.shipToLocation[1]
      this.orderForm.shipTo.district = this.shipToLocation[2]
    }
  }
}

const validateWeight = (rule, value, callBack) => {
  if (parseFloat(value) <= 0) {
    return callBack(new Error('Weight should be a number greater than 0'))
  } else {
    callBack()
  }
}
const rules = {
  name: [{ required: true, message: 'Please input name', trigger: 'blur' }],
  phone: [
    { required: true, message: 'Please input phone number', trigger: 'blur' },
    {
      type: 'string',
      pattern: /^[0-9]*$/,
      message: 'Phone number should be digits only',
      triger: 'change'
    },
    {
      min: 10,
      max: 10,
      message: 'Phone number should be 10 digits',
      triger: 'change'
    }
  ],
  address1: [
    { required: true, message: 'Please input address', trigger: 'blur' }
  ],
  address2: [{ required: false }],
  city: [{ required: true, message: 'Please input city', trigger: 'blur' }],
  state: [{ required: true, message: 'Please input state', trigger: 'blur' }],
  postal: [
    { required: true, message: 'Please input postal code', trigger: 'blur' },
    {
      type: 'string',
      pattern: /^[0-9]*$/,
      message: 'Postal code should be digits only',
      triger: 'change'
    },
    {
      min: 5,
      max: 5,
      message: 'Postal code should be 5 digits',
      triger: 'change'
    }
  ]
}
const rulesReceiver = {
  name: [{ required: true, message: 'Please input name', trigger: 'blur' }],
  phone: [
    { required: true, message: 'Please input phone number', trigger: 'blur' },
    {
      type: 'string',
      pattern: /^[0-9]*$/,
      message: 'Phone number should be digits only',
      triger: 'change'
    },
    {
      min: 11,
      max: 11,
      message: 'Phone number should be 11 digits',
      triger: 'change'
    }
  ],
  addressInfo: [
    { required: true, message: 'Please input address', trigger: 'blur' }
  ],
  province: [
    { required: true, message: 'Please select region', trigger: 'change' }
  ],
  postal: [
    { required: true, message: 'Please input postal code', trigger: 'blur' },
    {
      type: 'string',
      pattern: /^[0-9]*$/,
      message: 'Postal code should be digits only',
      triger: 'change'
    },
    {
      min: 6,
      max: 6,
      message: 'Postal code should be 6 digits',
      triger: 'change'
    }
  ],
  ID: [
    { required: true, message: "Please input reveiver's ID", trigger: 'blur' },
    {
      type: 'string',
      pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/,
      message: 'Please enter valid ID number',
      triger: 'blur'
    }
  ]
}
const rulesItems = {
  weight: [
    {
      required: true,
      message: 'Please estimate package weight(lb)',
      trigger: 'blur'
    },
    {
      type: 'string',
      validator: validateWeight,
      message: 'Weight should be a number greater than 0',
      triger: 'change'
    }
  ]
}
const rulesAddInfo = {
  packing: [
    { required: true, message: 'Please select a packing', trigger: 'change' }
  ],
  insurance: [
    {
      required: true,
      message: 'Please select an insurance for your package',
      trigger: 'change'
    }
  ],
  remark: [{ required: false }]
}
</script>

<style>
.edit-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  -webkit-overflow-scrolling: touch;
}
.edit-form {
  box-sizing: border-box;
  padding: 20px;
  width: 600px;
  margin: auto;
  height: 80vh;
  overflow: auto;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 28px 50px -25px rgba(0, 0, 0, 0.5);
}
.edit-title {
  position: fixed;
  top: 10vh;
  left: auto;
  width: 560px;
  right: auto;
  z-index: 1100;
  background-color: #ffffff;
  padding: 20px 0 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1rem;
  font-weight: bold;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.edit-tabs {
  margin-top: 52px;
}
@media screen and (max-width: 650px) {
  .edit-form {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
    margin: auto;
    height: 100vh;
    overflow: auto;
    background: #ffffff;
    border-radius: 0;
  }
  .edit-title {
    content: "";
    position: fixed;
    width: auto;
    top: 0;
    left: 0;
    right: 0;
    padding: 20px 20px 10px 20px;
    box-sizing: border-box;
    background-color: #ffffff;
    z-index: 1100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1rem;
    font-weight: bold;
  }
}
</style>
